module.exports = __webpack_public_path__ + "img/KinokoTable13.0db19d0a.jpg";